import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-lead-notes',
  templateUrl: './lead-notes.component.html',
  styleUrls: ['./lead-notes.component.scss']
})
export class LeadNotesComponent {

  btnLoading = false;
  leadNotesList: any[] = [];
  loading = false;
  @Output() close = new EventEmitter<void>();
  @Output() reloadLeadList = new EventEmitter<void>();
  @Input() editFieldValues: any;

  editNoteData: any;

  constructor(private toaster: ToastrService,
    private api: LeadService,
    private localstorage: LocalStorageService,
    private modalService: NgbModal,
    private tracker: TrackingService
  ) { }

  openModal(content: any) {
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }

  closeModal() {
    this.close.emit();
  }

  ngOnInit() {
    this.getLeadNotes();
  }

  getLeadNotes() {
    this.loading = true;

    const payload = {
      "client_id": this.localstorage.getClientId(),
      "lead_id": this.editFieldValues.lead_id,
    }

    this.api.getAllNotes(payload).subscribe({
      next: (res) => {
        this.leadNotesList = res || [];
        this.loading = false;
        
        // ✅ TRACK viewing notes
        const desc = `Viewed notes for lead ID: ${payload.lead_id}`;
        this.tracker.track('View', 'Lead Notes', desc);
      },
      error: (err) => {
        this.toaster.error(err.error.message || 'Something went wrong');
        this.loading = false;
      }
    });
  }

  reloadTable() {
    this.getLeadNotes();
    this.reloadLeadList.emit();
  }

  openModalEdit(content: any, data: any) {
    this.editNoteData = data;
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
    
    // ✅ TRACK opening edit modal
    const desc = `Opened edit modal for note ID: ${data?.note_id}`;
    this.tracker.track('Open Modal', 'Edit Lead Note', desc);
  }

  openModalDelete(content: any, data: any) {
    this.editNoteData = data;
    this.modalService.open(content, { size: 'md', scrollable: true, centered: true });
      // ✅ TRACK opening delete modal
    const desc = `Opened delete modal for note ID: ${data?.note_id}`;
    this.tracker.track('Open Modal', 'Delete Lead Note', desc);
  }

  handleDeleteNote(modal:any) {
    this.btnLoading = true;

    const payload = {
      "note_id": this.editNoteData.note_id,
      "client_id": this.localstorage.getClientId(),
      "lead_id": this.editFieldValues.lead_id,
    }

    this.api.deleteNote(payload).subscribe({
      next: (res) => {
        this.toaster.success(res.message);
        this.btnLoading = false;
        this.reloadTable();
        this.closeModal();
        modal.dismiss('Cross click')
         // ✅ TRACK note deletion
        const desc = `Deleted note ID: ${payload.note_id} for lead ID: ${payload.lead_id}`;
        this.tracker.track('Delete', 'Lead Note', desc);
      },
      error: (err) => {
        this.toaster.error(err.error.message || 'Something went wrong');
        this.btnLoading = false;
      }
    });
  }

}
